var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepublicOfSrpska(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_3667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1111H28V17.8889H0V10.1111Z",
    fill: "#0C4076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 21.8251 0.327777 22.6164 0.911223 23.1999C1.49467 23.7833 2.28599 24.1111 3.11111 24.1111H24.8889C25.714 24.1111 26.5053 23.7833 27.0888 23.1999C27.6722 22.6164 28 21.8251 28 21V17.8889H0V21Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 7C28 6.17488 27.6722 5.38356 27.0888 4.80011C26.5053 4.21666 25.714 3.88889 24.8889 3.88889H3.11111C2.28599 3.88889 1.49467 4.21666 0.911223 4.80011C0.327777 5.38356 0 6.17488 0 7L0 10.1111H28V7Z",
    fill: "#C6363C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_3667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicOfSrpska);
export default __webpack_public_path__ + "static/media/republic_of_srpska.385d86bfc842f0c825a06329c4eeb5e3.svg";
export { ForwardRef as ReactComponent };